// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__n8O7d","colMin":"styles_colMin__ZUzvA","colCheckbox":"styles_colCheckbox__3M1WH"};